export const photoLabels = {
  front: "Front of vehicle",
  right: "Right side of vehicle",
  left: "Left side of vehicle",
  back: "Back of vehicle",
  mileage: "Mileage",
  Exterior: "Exterior Panels",
  Tyres: "Tyres",
  Wheels: "Trims/ alloy wheels",
  Interior: "Interior",
  Glass: "Glass",
  "Mechanical & Electrical": "Dashboard warning lights"
};
